import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { KeyRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { api, ApiError } from '@/lib/axios'

async function resetUserPassword(email: string) {
  return api.backend.post('/user/forgot-password', { email })
}

export function useResetUserPassword() {
  const { t } = useTranslation(['registers', 'common'])
  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    string
  >({
    mutationKey: ['/user/forgot-password'],
    mutationFn: resetUserPassword,
    onSuccess: () => {
      toast(Toast, {
        toastId: 'reset-password-success',
        data: {
          type: 'success',
          icon: KeyRound,
          title: t('users.reset_password.toast_success.title'),
          description: t('users.reset_password.toast_success.description'),
        },
      })
    },
    onError: (error) => {
      toast(Toast, {
        toastId: 'reset-password-error',
        data: {
          type: 'danger',
          icon: KeyRound,
          title: t('users.reset_password.toast_error.title'),
          description:
            error?.response?.data?.friendlyMessage ||
            t('users.reset_password.toast_error.description'),
        },
      })
    },
  })

  const handleResetUserPassword = async (email: string) => {
    await mutateAsync(email)
  }

  return {
    handleResetUserPassword,
    isPendingResetPassword: isPending,
  }
}
